import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getGamificationAudioguidesAdmin,
  deleteGamificationAudioguide,
} from "../../../../api/gamificationAudioguide";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

function getData(items) {
  return items.map((row) => ({
    id: row._id,
    id_pid: row.id_pid,
    name_lugar: row.name_lugar || '',
    links: Array.isArray(row.links) ? row.links.length : 0,
    updatedAt: row.updatedAt,
  }))
}

export default function GamificationAudioguidesPage() {
  const [data, setData] = useState([]);
  const [itemId, setItemId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() =>
              history.push("/edit-gamification-audioguide/" + cell)
            }
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setItemId(cell);
              setOpenConfirmDialog(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "id_pid", text: "id_pid", sort: true },
    { dataField: "name_lugar", text: "name_lugar", sort: true },
    { dataField: "links", text: "Enlaces", sort: true },
    {
      dataField: "updatedAt",
      text: "Actualizado",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getGamificationAudioguidesAdmin()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se pudieron cargar los registros.",
        });
      });
  }, [refresh]);

  return (
    <Card>
      <CardHeader title="Gamificación y Audioguías">
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => history.push("/edit-gamification-audioguide")}
          >
            Añadir
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Table data={getData(data)} columns={columns} />
        <ConfirmDialog
          title="¿Eliminar este registro?"
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteGamificationAudioguide(itemId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({
                    title: "Eliminado",
                    customMessage: "Registro eliminado.",
                  });
                  setRefresh(true);
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: "No se pudo eliminar." });
              });
          }}
        />
      </CardBody>
    </Card>
  );
}
